module.exports = __webpack_public_path__ + "img/coffeetogoextrasmall.8fd0d3f5.jpg";